<core-upload
	[label]="field.label"
	[required]="field.validation?.required || false"
	[uploadLabel]="field.uploadLabel || 'Upload a file'"
	[accept]="'image/*,.pdf'"
	[showStatus]="false"
	[showStatusBar]="false"
></core-upload>
